<template>
  <div class="dashboard wrap">
    <div class="back-link">
      <router-link :to="{name: 'DDS'}">
        <rir-icon icon="arrow-left"></rir-icon>
        Назад к ДДС
      </router-link>
    </div>

    <h1>
      Дежурно-диспетчерские службы<br>
      МО г. Южно-Сахалинск
    </h1>
    <DDSEditForm :employee.sync="employee"></DDSEditForm>

    <div class="line-margin">
      <div class="light-button" @click="addChilrendEmployee()"><span class="icon icon-plus"></span> Добавить сотрудника
      </div>
    </div>

    <div class="line-margin">
      <DDSEditForm
          v-for="(employee, index) in childrenEmployee"
          :key="index"
          :class="`employee-${index+1}`"
          :ref="`employee-${index+1}`"
          @onDelete="deleteEmployee(index)"
          :employee.sync="employee"></DDSEditForm>
    </div>
    <div style="height:100vh;"></div>
  </div>
</template>

<script>
import {EmployeeApi} from '@/api/EmployeeApi';
import Employee from "@/models/Employee";
import CanEditResponse from "@/models/CanEditResponse";
import DDSEditForm from "@/components/DDSEditForm";

export default {
  name: 'DDSCardEdit',
  components: {
    DDSEditForm
  },
  props: {
    uuid: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      employee: new Employee(),
      canEdit: new CanEditResponse(),
      childrenEmployee: [],

    }
  },
  mounted () {
    this.loadEmployee();
  },
  computed: {
    maxOrder() {
      return  this.childrenEmployee.length ? Math.max(...this.childrenEmployee.map(el => el.order)) + 1 : 0
    }
  },
  methods: {
    async loadEmployee () {
      this.employee = await EmployeeApi.getByUuid(this.uuid);
      let childrenEmployee = await EmployeeApi.getList({
        parentId: this.employee.id,
        page: 0,
        size: 50
      });
      this.childrenEmployee = childrenEmployee.content.map(el => {
        return new Employee(el);
      });
    },
    async newEmployeeId () {
      let data = await EmployeeApi.create({
        name: `(${this.childrenEmployee.length + 1}) Новый сотрудник`,
        parentId: this.employee.id,
        order: this.maxOrder
      })
      return data.id
    },
    addChilrendEmployee () {
      this.childrenEmployee.push(new Employee({
        id: this.newEmployeeId(),
        parentId: this.employee.id,
        order: this.maxOrder
      }));

      this.loadEmployee();
      // прокрутить к новой карточке
      this.$nextTick(function () {
        const refOfNewEl = `employee-${this.childrenEmployee.length}`
        //this.$refs[refOfNewEl]
        const el = this.$el.getElementsByClassName(refOfNewEl)[0]
        el && el.scrollIntoView({ block: 'center', behavior: "smooth" })
      })
    },
    deleteEmployee (index) {
      this.childrenEmployee.splice(index, 1);
    }
  }
}
</script>

<style scoped>

</style>
